import React from "react";

const NonRevenueWaterSvg: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" 
            width="18" 
            height="18" 
            viewBox="0 0 24 24" 
            fill="none">
            <path d="M2 15V5M6 15V5M18 15V5M22 15V5M2.19995 6.23001H21.92M2.19995 13.53H21.92M8.95996 2H14M11.48 2.54001V5.06001M13.66 19.23L12.31 16.68L10.96 19.23C10.85 19.46 10.77 19.73 10.77 20.01C10.77 20.93 11.46 21.68 12.3 21.68C13.14 21.68 13.83 20.93 13.83 20.01C13.83 19.73 13.76 19.46 13.64 19.23H13.66Z" stroke="black" stroke-width="2" stroke-linecap="round" />
        </svg>
    );
};

export default NonRevenueWaterSvg;
